import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useCountdown } from "../../Hooks";
import { addMinutes } from "../../Utils/functions";
import { useVerfiyCode } from "./Hooks";

const VerfiyCode = () => {
  const { form, setForm, sendCode, mobile, navigate, loading } =
    useVerfiyCode();

  return (
    <div className="login row">
      <div className="box col-md-4">
        <div className="display">
          <img
            style={{ width: "124px" }}
            src={require("../../Assets/images/logo.png")}
          />
        </div>

        <div>
          <div>
            <div className="font2">کد تایید را وارد کنید</div>
            <div className="font3">
              کد تایید برای شماره <span>{}</span> پیامک شد
            </div>
          </div>
          <div>
            <input
              placeholder="12345"
              className="otp-input"
              onChange={({ target: { value } }) => {
                setForm({ ...form, code: value });
              }}
              style={{ textAlign: "left", letterSpacing: "5px" }}
            />
          </div>
          <button
            onClick={sendCode}
            className="primary-btn"
            style={{ fontSize: "15px" }}
          >
            {loading ? <Spinner size="sm" /> : "تایید"}
          </button>
          <p className="text-center mt-3 mb-1 fs-12 color-text-2">
            <span> </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerfiyCode;
